import { GeoJSON } from 'ol/format';
import { Feature } from 'ol';
import { WKT } from 'ol/format';
import { inflateCoordinatesArray, inflateMultiCoordinatesArray } from 'ol/geom/flat/inflate';
import { createInstanceFactory } from '@tmapy/utils';
const geoJsonFormat = new GeoJSON();
const SYMBOL_GEOJSON = Symbol('GeoJSON');
const SYMBOL_WKT = Symbol('WKT');
export const getGeoJSON = (feature) => {
    const extendedFeature = feature;
    let geoJson = extendedFeature[SYMBOL_GEOJSON];
    if (geoJson)
        return geoJson;
    if (feature instanceof Feature) {
        geoJson = geoJsonFormat.writeFeatureObject(feature);
        geoJson.crs = feature.get('_crs');
        feature.once('change', () => {
            extendedFeature[SYMBOL_GEOJSON] = null;
        });
    }
    else {
        let geometry;
        switch (feature.getType()) {
            case 'Point': {
                geometry = {
                    type: 'Point',
                    coordinates: feature.getFlatCoordinates(),
                };
                break;
            }
            case 'LineString': {
                const coordinates = inflateCoordinatesArray(feature.getFlatCoordinates(), 0, (feature.getEnds() ?? []), 2);
                geometry = {
                    type: 'LineString',
                    coordinates,
                };
                break;
            }
            case 'Polygon': {
                const coordinates = inflateCoordinatesArray(feature.getFlatCoordinates(), 0, (feature.getEnds() ?? []), 2);
                geometry = {
                    type: 'Polygon',
                    coordinates,
                };
                break;
            }
            case 'MultiPoint': {
                const flatCoordinates = feature.getFlatCoordinates();
                const coordinates = [];
                const stride = 2;
                let i = 0;
                for (let j = 0; j < flatCoordinates.length; j += stride) {
                    coordinates[i++] = flatCoordinates.slice(j, j + stride);
                }
                geometry = {
                    type: 'MultiPoint',
                    coordinates,
                };
                break;
            }
            case 'MultiLineString': {
                const coordinates = inflateMultiCoordinatesArray(feature.getFlatCoordinates(), 0, feature.getEnds(), 2);
                geometry = {
                    type: 'MultiLineString',
                    coordinates,
                };
                break;
            }
            case 'MultiPolygon': {
                const coordinates = inflateMultiCoordinatesArray(feature.getFlatCoordinates(), 0, feature.getEnds(), 2);
                geometry = {
                    type: 'MultiPolygon',
                    coordinates,
                };
                break;
            }
            // case 'LinearRing':
            // case 'Circle':
            // case 'GeometryCollection':
            default: {
                throw new Error(`Unsupported geometry type: '${feature.getType()}'`);
            }
        }
        const properties = feature.getProperties();
        geoJson = {
            id: feature.getId() ?? feature.get('id'),
            type: 'Feature',
            geometry: geometry,
            properties,
            crs: properties._crs,
        };
    }
    extendedFeature[SYMBOL_GEOJSON] = geoJson;
    return geoJson;
};
export class ManagedGeoJSON extends GeoJSON {
    constructor(opts, layerId) {
        super(opts);
        this.readFeatureFromObject = createInstanceFactory((geoJson) => {
            const feature = super.readFeatureFromObject(geoJson);
            feature.set('layerId', layerId);
            // duplicita LayerId (nas identifikacni parametr, ktery je vyuzivan cross monorepo)
            // a layer (z duvodu nasazeni ol-mapbox-style, ktery interne pouziva prave tento parametr)
            // -> sjednoceni by bylo dosti problematicke a proto se k tomuto kroku uchylime
            // v pripade potvrzeni technologie pro stylovani
            feature.set('layer', layerId);
            feature[SYMBOL_GEOJSON] = geoJson;
            feature[SYMBOL_WKT] = null;
            feature.on('change', () => {
                feature[SYMBOL_GEOJSON] = null;
            });
            feature.on('change:geometry', () => {
                feature[SYMBOL_GEOJSON] = null;
                feature[SYMBOL_WKT] = null;
            });
            return feature;
        });
    }
}
const wktFormat = new WKT();
export const getWKT = (feature) => {
    const extendedFeature = feature;
    let wkt = extendedFeature[SYMBOL_WKT];
    if (wkt)
        return wkt;
    wkt = wktFormat.writeFeature(feature);
    extendedFeature[SYMBOL_WKT] = wkt;
    return wkt;
};
//# sourceMappingURL=ManagedGeoJSON.js.map